import styled from "styled-components";

import colors from "@src/common/styles/colors";
import { DEFAULT_MARGIN_M, DEFAULT_MARGIN_S } from "@src/common/styles/const";
import { defaultLetterSpacing, media } from "@src/common/styles/mixins";

export const HeadersTable = styled.table`
  width: 100%;
  border-spacing: 0 8px;
  border-collapse: separate;
`;

export const HeadersTableWrapper = styled.div`
  overflow: auto;
  font-size: 12px;
  ${media.up("MOBILE")`
    max-height: 50vh;
  `}
`;

export const TableHeader = styled.th`
  color: ${colors.gray3};
  font-weight: 400;
  text-transform: uppercase;
  ${defaultLetterSpacing}
  padding: ${DEFAULT_MARGIN_S}px ${DEFAULT_MARGIN_M}px;
`;

export const TableValue = styled.td`
  background-color: ${colors.white};
  padding: ${DEFAULT_MARGIN_S}px ${DEFAULT_MARGIN_M}px;

  &:first-child {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }

  &:last-child {
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }
`;
